import en from "./en.json";
import es from "./es.json";
import fr from "./fr.json";
import de from "./de.json";
import ar from "./ar.json";

export const defaultLocale = "en";

export const locales = {
  en: {
    name: "English",
    messages: en,
  },
  es: {
    name: "Español",
    messages: es,
  },
  fr: {
    name: "Français",
    messages: fr,
  },
  de: {
    name: "Deutsch",
    messages: de,
  },
  ar: {
    name: "العربية",
    messages: ar,
  },
};

export const getLocaleMessages = (locale) => {
  return locales[locale]?.messages || locales[defaultLocale].messages;
};

export const formatMessage = (messages, key, values = {}) => {
  const keys = key.split(".");
  let message = keys.reduce((obj, k) => obj?.[k], messages);

  if (!message) return key;

  return message.replace(/\{\{(\w+)\}\}/g, (_, key) => values[key] || "");
};
